import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    texts_status:-1,
    isUpdate:true,
    isTabShow:true,
    isTable:true,
    com_id:'',
    pageTitle: '',
    pub_height:document.documentElement.clientHeight - 105,
    menuList:[]
  },
  mutations: {
    changeValue: (state, obj) => {
      state.editableTabsValue = obj;
    },
    changeTabStatus: (state, status) => {
      state.isTable = status;
    }
  },
  actions: {
  }
})
